import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, FormControl, ControlLabel, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";

import mmkLogo from '../../assets/images/logo.png';
import './newPasswordRequired.css';
import showIcon from '../../assets/images/password-show.svg';
import hideIcon from '../../assets/images/password-hide.svg';
import checkValidIcon from '../../assets/images/password-check-valid.svg';
import checkInvalidIcon from '../../assets/images/password-check-invalid.svg';
import errorIcon from '../../assets/images/error-exclamation-point.svg';
import Commonfooter from '../UI/FooterCommon/Commonfooter';
import Checkbox from '../UI/Checkbox/Checkbox';
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';
import axios from '../../services/axios-service';
/**
* @desc  Set new-password for new login
* @version 1.0.1
* @author  Lakshmikanth
*/

class NewPasswordRequiredForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isFirstTimeLogin: (props.defaultUsername) ? true : false,
      password: '',
      confirmPassword:'',
      acceptTerms: false,
      error: '',
      errorPosition:''
    };

    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeConfirmPassword = this.handleChangeConfirmPassword.bind(this);
    this.handleOnPasswordBlur = this.handleOnPasswordBlur.bind(this);
    this.handleOnConfirmPasswordBlur = this.handleOnConfirmPasswordBlur.bind(this);
    this.handleChangeAcceptTerms = this.handleChangeAcceptTerms.bind(this);
    this.resetError = this.resetError.bind(this);
  }
/**
 * @desc Save new set password
 * @param event
 * @return null
 */
  onSubmit = (event) => {
    event.preventDefault();
    const { password, confirmPassword } = this.state;

    if (password === confirmPassword) {
      this.props.onSubmit(password && confirmPassword)
      .then(() => {
        this.setState({
          password: '',
          confirmPassword:''
        })

        axios.post('/galaxy/user/activity',{ email: this.props.username, activity: "FIRST_LOGIN"})
        .then(resp => {
          localStorage.setItem('firstLogin', 1);
        })
        .catch(err => ConsoleLog(err));
      })
      .catch((err) => {      
        ConsoleLog("err",err,(err.code === 'InvalidPasswordException'), err.code );
        if (err.code === 'UserNotFoundException' || err.code === "InvalidParameterException" || err.code === "NotAuthorizedException") {
          this.setState({ error: 'Invalid username or password.' });
        } else if (err.code === 'LimitExceededException'||err.code === 'NotAuthorizedException') {
          this.setState({ error: 'Attempt limit exceeded, please try again later.', errorPosition:'password' });
        } else if (err.code === 'InvalidPasswordException') {
          this.setState({ error: 'Minimum password requirements were not met.', errorPosition:'password' });
        } else {
          this.setState({ error: err.message, errorPosition:'password' })
        }
      });
    } else {
      this.setState({ error: "Password and confirm-password should be same", errorPosition: 'confirmPassword' })
    }
  }

  /**
   * @desc Set error on blur
   */
  handleOnPasswordBlur = () => {
    const { password } = this.state;
    if (!password) {        
      this.setState({
        errorPosition: ['password'], 
      });
    }
  }

  /**
   * @desc Set error on blur
   */
  handleOnConfirmPasswordBlur = () => {
    const { password, confirmPassword } = this.state;
    if (password !== confirmPassword){
      this.setState({
        errorPosition: ['confirmPassword'], 
      });
    }
  }

  /**
   * @desc Reset error position
   */
  resetError = () => {
    this.setState({
      errorPosition: '', 
    });
  }

  /**
   * @desc Fill new set password
   * @param event
   * @return null
   */
  handleChangePassword = (event) => {
    const password = event.target.value.trim();
    this.setState({ password: password, error:'', errorPosition: ''});
  }
  /**
   * @desc Fill confirm set password
   * @param event
   * @return null
   */
  handleChangeConfirmPassword = (event) => {
    const password = event.target.value.trim();
    this.setState({ confirmPassword: password, error:'', errorPosition: ''});
  }
  /**
   * @desc Handle the terms checkbox
   * @param event
   * @return null
   */
  handleChangeAcceptTerms = (event) => {
    const terms = event.target.checked;
    this.setState({ acceptTerms: terms });
  }
  /**
   * @desc Show/Hide password
   * @param event
   * @return null
   */
  passwordView=()=>{
    this.setState({ passwordView:!this.state.passwordView });
  }
  /**
   * @desc Show/Hide confirm-password
   * @param event
   * @return null
   */
  confirmPasswordView=()=>{
    this.setState({ confirmPasswordView:!this.state.confirmPasswordView });
  }

  render() {
    const { errorPosition, error, password, confirmPassword, passwordView, confirmPasswordView, isFirstTimeLogin, acceptTerms } = this.state;
    const isPasswordMatched = (password && password === confirmPassword) ? true : false;
    const isPasswordLength = (password && password.length >= 8) ? true : false;
    const isSubmitDisabled = (isPasswordLength && isPasswordMatched && acceptTerms) ? true : false;
    return (
      <React.Fragment>
        <div className="new-password-required-section">  
          <div className="new-password-required-wrapper paddingtop-80">
            <div className="new-password-required-container">            
              <div className="form-wrapper">
                <div className="text-center"> 
                  <div className="new-password-required-title">Set New Password</div>
                </div>
                
                <form onSubmit={this.onSubmit}>
                  <FormGroup>
                    <ControlLabel>New Password</ControlLabel>
                    <div className="new-password-required-container--password-field">
                      <FormControl
                        id="formEventNewPasswordText"
                        label="New Password"
                        type={(this.state.passwordView) ? "text" : "password"}
                        placeholder="Enter new password"
                        onChange={this.handleChangePassword}
                        onBlur={this.handleOnPasswordBlur}
                        onFocus={this.resetError}
                        autoFocus
                        value={this.state.password}
                        className={(errorPosition.includes("password")) ? "invalid-error" : "text-field"}
                        margin="normal"
                      />
                      <div className="new-password-control" onClick={() => this.passwordView() }>{this.state.passwordView ? <img src={hideIcon}/> : <img src={showIcon}/>}</div>
                    </div>
                  </FormGroup>

                  { (error) ? 
                    <p className="error-message"><img src={errorIcon} title="Error" />{error}</p>
                  : null }

                  <FormGroup>
                    <ControlLabel>Confirm Password</ControlLabel>
                    <div className="new-password-required-container--password-field">
                      <FormControl
                        id="formEventConfirmPasswordText"
                        label="Confirm Password"
                        type={(this.state.confirmPasswordView) ? "text" : "password"}
                        placeholder="Confirm new password"
                        onChange={this.handleChangeConfirmPassword}
                        onBlur={this.handleOnConfirmPasswordBlur}
                        onFocus={this.resetError}
                        value={this.state.confirmPassword}
                        className={(errorPosition.includes("confirmPassword")) ? "invalid-error" : "text-field"}
                        margin="normal"
                      />
                      <div className="new-password-control" onClick={() => this.confirmPasswordView() }>{this.state.confirmPasswordView ? <img src={hideIcon}/> : <img src={showIcon}/>}</div>
                    </div>
                  </FormGroup>

                  <div className="validation-list-cont">
                    <div>You password must</div>
                    <ul className="validation-list">                    
                      { (isPasswordLength) ? 
                        <li className="validation-list--item"><img src={checkValidIcon} title="Error" />Be minimum 8 characters</li>
                      : <li className="validation-list--item validation-list--item---invalid"><img src={checkInvalidIcon} title="Error" />Be minimum 8 characters</li> }

                      { (isPasswordMatched) ? 
                        <li className="validation-list--item"><img src={checkValidIcon} title="Error" />Match your password confirmation</li>
                      : <li className="validation-list--item validation-list--item---invalid"><img src={checkInvalidIcon} title="Error" />Match your password confirmation</li> }
                    </ul>
                  </div>

                  <div className="terms-conditions-cont">
                    <Checkbox
                      checked={acceptTerms} 
                      onChange={this.handleChangeAcceptTerms}
                    />
                    <div className="terms-conditions-cont--text">
                      <p>I accept these <Link to={"/content-pages/TermsAndConditions"} target="_blank" onClick={() => window.scrollTo(0, 0)}>User Terms & Conditions</Link></p>
                      <p className="terms-conditions-cont--text-upper">                            
                        I UNDERSTAND THAT THESE USER TERMS & CONDITIONS, TOGETHER WITH THE <a href="https://privacy.morganmckinley.com/" target="_blank">PRIVACY STATEMENT</a> GOVERN MY USE OF MORGAN McKINLEY SERVICES
                      </p>
                    </div>
                  </div>

                  <Button type="submit" className="btn" variant="raised" color="default" disabled={!isSubmitDisabled}>
                    Set New Password
                  </Button>
                </form>              
              </div>
            </div>
          </div>
        </div>
        <div className="p-policy">
          <Commonfooter />
        </div>
      </React.Fragment>
    )
  }
}

NewPasswordRequiredForm.propTypes = {
  onSubmit: PropTypes.func,
  error: PropTypes.string,
};

export default NewPasswordRequiredForm;



// WEBPACK FOOTER //
// ./src/components/Authentication/NewPasswordRequiredForm.js